frappe.provide("frappe.help.help_links");
// @dokos: no upstream help links — they point at frappe/ERPNext docs (removed in 63a04073bf3)
